import { ModalWindow } from '@cian/ui-kit';

import * as React from 'react';

import { ErrorContent } from '../../components/ErrorContent';
import { ESubscriptionLimitType } from '../../types/context';
import { useContext } from '../../utils/useContext';

import { AVAILABLE_STATUS_LIST, TITLE_MAPPING } from './constants';

export const FallbackModalContainer: React.FC = () => {
  const context = useContext();
  const offerId = context.lastUsedOfferId;

  const content = React.useMemo(() => {
    switch (context.status) {
      case 'failed': {
        const { checkContactsAccess } = context;

        // Если offerId недоступен, не показываем кнопку retry
        if (!offerId) {
          return null;
        }

        return (
          <ErrorContent
            onRetry={() => checkContactsAccess({ offerId, limitType: ESubscriptionLimitType.PhoneNumber })}
          />
        );
      }
      default:
        return null;
    }
  }, [context, offerId]);

  if (!AVAILABLE_STATUS_LIST.includes(context.status)) {
    return null;
  }

  return (
    <ModalWindow
      fixed
      content={content}
      escape={false}
      maxWidth={540}
      open={context.open}
      size="M"
      title={TITLE_MAPPING[context.status]}
      width="100%"
      onClose={context.onClose}
    />
  );
};
